import 'ol/ol.css';
import Map from 'ol/Map';
import TileLayer from 'ol/layer/Tile';
import View from 'ol/View';
import XYZ from 'ol/source/XYZ';
import OSM from 'ol/source/OSM';
import {OverviewMap, ZoomSlider, Control, defaults as defaultControls} from 'ol/control';
import {fromLonLat, toLonLat} from 'ol/proj';
import MousePosition from 'ol/control/MousePosition';
import {createStringXY} from 'ol/coordinate';
import {toStringHDMS} from 'ol/coordinate';
import LayerGroup from 'ol/layer/Group';
import { transform } from 'ol/proj';
import Graticule from 'ol/layer/Graticule';
import Feature from 'ol/Feature';
import Point from 'ol/geom/Point';
import Style from 'ol/style/Style';
import Icon from 'ol/style/Icon';
import VectorSource from 'ol/source/Vector';
import VectorLayer from 'ol/layer/Vector';
import VectorTileLayer from 'ol/layer/VectorTile';
import VectorTile from 'ol/source/VectorTile';
import MVTFormat from 'ol/format/MVT';
import GeoJSON from 'ol/format/GeoJSON';
import {createXYZ} from 'ol/tilegrid';
import * as olInteraction from 'ol/interaction';

let mapVisibleStatus = document.getElementById('map_status');
let mapStatus = mapVisibleStatus.getAttribute('map-status-id');

if (mapStatus == "true") {
  /** 変数設定(defalt) */
  /** 緯度経度 長野県 白馬村大字北城 なうここの画面サイズで日本地図全体表示時の中央です */
  let lon = 137.8156; // 経度
  let lat = 36.8090;  // 緯度
  let direction = 0;  // 記事方角
  let zoomRate = 15; // 拡大率
  let iconPath = "aaa.png"; // 空のデータの場合地図が表示されないのでroute matchのエラーにする


  /** viewに仕込んである情報を取得する */
  let lonDoc = document.getElementById('longitude');
  let latDoc = document.getElementById('latitude')
  let directionDoc = document.getElementById('direction');
  let zoomDoc = document.getElementById('zoom_rate');
  let iconDoc = document.getElementById('camera_icon')

  // Controllerから経緯度を取得
  if(lonDoc != null && latDoc != null) {
    lon = lonDoc.getAttribute('data-longitude-id');
    lat = latDoc.getAttribute('data-latitude-id');  
  }

  // Controllerから撮影方角を取得
  if(directionDoc != null) {
    direction = directionDoc.getAttribute('data-direction-id');
  }

  // Cpontrollerから初回地図表示時の地図拡大率を取得
  if(zoomDoc != null) {
    zoomRate = zoomDoc.getAttribute('data-zoom-id');
  }

  // カメラアイコンのパスを指定
  if(iconDoc != null) {
    let iconJson = iconDoc.getAttribute('data-icon-id');
    iconJson = JSON.parse(iconJson);
    let num = Number(iconJson[0][1]);
    String(num).length <= 1 ? 
    iconPath = "../assets/camera_icon/"+iconJson[0][0]+"0"+iconJson[0][1]+".png" 
    : iconPath = "../assets/camera_icon/"+iconJson[0][0]+iconJson[0][1]+".png";
  }

  // 初回表示座標
  let lonlat = fromLonLat([lon, lat], "EPSG:3857");

  // 動的なレイヤーの情報を取得
  let data = document.getElementById('data').value;
  let parseData = JSON.parse(data);
  let layerArray = [];
  let objMap = new Map();
  let overlaySlider = [];
  let sliderLayer = [];

  for(let i=0; i<parseData.length; i++){
    let ret = layerIsolate(parseData[i]);
    if (ret == null) continue; // ありえないが、tileのtypeが範囲外の場合は次のtile生成に(View側は管理できない)
     let id = parseData[i]['id'];
     let rangeId = "my_range"+id;
     overlaySlider[i] = document.getElementById(rangeId);
     sliderLayer[i] = ret;
     overlaySlider[i].addEventListener('input', function(evt){
       sliderLayer[i].setOpacity(this.value*0.01);
     });
     objMap.set(id, ret);
  };

  function layerIsolate(data) {
    let type = data['layer_type'];
    let url = data['layer_url'];
    let attr = data['layer_attr'];
    let tile;
    switch(type) {
        case 'pbf':
            tile = pbfLayerCreate(url,attr);
            break;
        case 'xyz':
            tile = xyzLayerCreate(url,attr);
            break;
        case 'geojson':
            tile = geoJsonCreate(url,attr);
            break;
        default :
            return null;
    }
    layerArray.push(tile);
    tile.setVisible(false);
    tile.setOpacity(0.5);
    return tile;
  }

  function pbfLayerCreate(_url, _attr) {
    let layer = new VectorTileLayer({
      source: new VectorTile({
        attributions: _attr,
        url: _url,
        crossOrigin: 'anonymous',
        format: new MVTFormat(),
      }),
    });
    return layer;
  }

  function xyzLayerCreate(_url,_attr) {
    let layer = new TileLayer({
      type: "overlay",
      source: new XYZ({
        attributions: _attr,
        url: _url,
        crossOrigin: 'anonymous',
        projection: "EPSG:3857"
      }),
    });
    return layer;
  }

  function geoJsonCreate(_url, _attr) {
    let layer = new VectorTileLayer({
      source: new VectorTile({
        type: "overlay",
        attributions: _attr,
        projection: 'EPSG:3857',
        url: _url,
        crossOrigin: 'anonymous',
        format: new GeoJSON(),
        tileGrid: createXYZ(),
     })
    });
    return layer;  
  }
  /*********** カメラアイコンここから ***********/

  /**方位の角度をradianに変更**/
  let radian = direction * (Math.PI / 180);

  let iconFeature = new Feature({
    geometry: new Point(transform([lon,lat], "EPSG:4326", "EPSG:3857")),
    name: 'pin'
  });

  let iconStyle = new Style({
    image: new Icon( {
      src: iconPath,
      rotation: radian,
      scale: 1
    })
  });

  iconFeature.setStyle(iconStyle);

  let vectorSource = new VectorSource({
    features: [iconFeature]
  });
  let vectorLayer = new VectorLayer({
    source: vectorSource,
    zIndex: 1000,
    className: "main-capture"
  });

  /*********** カメラアイコンここまで ***********/

  /*********** 地図のレイヤーを生成する ***********/
  // 地理院地図(PC)
  let fullBaseLayer = new TileLayer ({
      title: "地理院地図",
      className: "main-capture",
      type: "base",
      source: new XYZ({
        crossOrigin: 'anonymous',
        attributions:
          "<a href='https://maps.gsi.go.jp/development/ichiran.html' target='_blank'>地理院タイル</a>  © <a href='https://www.openstreetmap.org/copyright' target='_blank'>OpenStreetMap</a> contributors.", //出典の表記
        url: "https://cyberjapandata.gsi.go.jp/xyz/std/{z}/{x}/{y}.png",
        attributionsCollapsible: true,
        projection: "EPSG:3857" // CRS指定
      })  
  });

  // 白地図(PC)
  let fullBlankLayer = new TileLayer({
    title: "白地図",
    type: "base",
    source: new XYZ({
      crossOrigin: 'anonymous',
      attributions:
        "<a href='https://maps.gsi.go.jp/development/ichiran.html' target='_blank'>地理院タイル</a>  © <a href='https://www.openstreetmap.org/copyright' target='_blank'>OpenStreetMap</a> contributors.", //出典の表記
      url: "https://cyberjapandata.gsi.go.jp/xyz/blank/{z}/{x}/{y}.png",
      attributionsCollapsible: true,
      projection: "EPSG:3857" // CRS指定
    })
  });
    
  // 標高図(PC)
  let fullReliefLayer = new TileLayer({
    title: "色別標高図",
    type: "base",
    source: new XYZ({
      crossOrigin: 'anonymous',
      attributions:
      "<a href='https://maps.gsi.go.jp/development/ichiran.html' target='_blank'>地理院タイル</a>  © <a href='https://www.openstreetmap.org/copyright' target='_blank'>OpenStreetMap</a> contributors.", //出典の表記
      url: "https://cyberjapandata.gsi.go.jp/xyz/relief/{z}/{x}/{y}.png",
      attributionsCollapsible: true,
      projection: "EPSG:3857" // CRS指定
    })
  });
    
  // open street map (PC)
  let fullOsmLayer = new TileLayer({
    title: "Open Street Map",
    type: "base",
    source: new XYZ({
      crossOrigin: 'anonymous',
      attributions:"© <a href='https://www.openstreetmap.org/copyright' target='_blank'>OpenStreetMap</a> contributors.",
      url: 'https://tile.openstreetmap.org/{z}/{x}/{y}.png',
      attributionsCollapsible: true,
      projection: "EPSG:3857" // CRS指定
    })
  });

  // 標高図(PC)
  let fullPhotoLayer = new TileLayer({
    title: "全国最新写真",
    type: "base",
    source: new XYZ({
      crossOrigin: 'anonymous',
      attributions:
      "<a href='https://maps.gsi.go.jp/development/ichiran.html' target='_blank'>地理院タイル</a>  © <a href='https://www.openstreetmap.org/copyright' target='_blank'>OpenStreetMap</a> contributors.", //出典の表記
      url: "https://cyberjapandata.gsi.go.jp/xyz/seamlessphoto/{z}/{x}/{y}.jpg",
      projection: "EPSG:3857" // CRS指定
    })
  });

  // GridStyle (PC)
  let fullGraticule = new Graticule({
    crossOrigin: 'anonymous',
    title: 'Graticule',
    type: 'overlay',
    showLabels: true,
    wrapX: false
  });
  layerArray.push(fullGraticule);

  // 地理院地図(PC)
  let baseOverlay = new TileLayer ({
    title: "地理院地図",
    type: "overlay",
    source: new XYZ({
      crossOrigin: 'anonymous',
      attributions:
        "<a href='https://maps.gsi.go.jp/development/ichiran.html' target='_blank'>地理院タイル</a>", //出典の表記
      url: "https://cyberjapandata.gsi.go.jp/xyz/std/{z}/{x}/{y}.png",
      projection: "EPSG:3857" // CRS指定
    })  
  });
  layerArray.push(baseOverlay);

  // 白地図(PC)
  let blankOverlay = new TileLayer({
    title: "白地図",
    type: "overlay",
    source: new XYZ({
      crossOrigin: 'anonymous',
      attributions:
        "<a href='https://maps.gsi.go.jp/development/ichiran.html' target='_blank'>地理院タイル</a>", //出典の表記
      url: "https://cyberjapandata.gsi.go.jp/xyz/blank/{z}/{x}/{y}.png",
      projection: "EPSG:3857" // CRS指定
    })
  });
  layerArray.push(blankOverlay);

  // 標高図(PC)
  let reliefOverlay = new TileLayer({
    title: "色別標高図",
    type: "overlay",
    source: new XYZ({
      crossOrigin: 'anonymous',
      attributions:
      "<a href='https://maps.gsi.go.jp/development/ichiran.html' target='_blank'>地理院タイル</a>", //出典の表記
      url: "https://cyberjapandata.gsi.go.jp/xyz/relief/{z}/{x}/{y}.png",
      projection: "EPSG:3857" // CRS指定
    })
  });
  layerArray.push(reliefOverlay);

  // open street map (PC)
  let osmOverlay = new TileLayer({
  title: "Open Street Map",
  type: "overlay",
  source: new XYZ({
      crossOrigin: 'anonymous',
      attributions:"© <a href='https://www.openstreetmap.org/copyright' target='_blank'>OpenStreetMap</a> contributors.",
      url: 'https://tile.openstreetmap.org/{z}/{x}/{y}.png',
      attributionsCollapsible: true,
      projection: "EPSG:3857" // CRS指定
    })
  });
  layerArray.push(osmOverlay);

  // 標高図(PC)
  let photoOverlay = new TileLayer({
    title: "全国最新写真",
    type: "overlay",
    source: new XYZ({
      crossOrigin: 'anonymous',
      attributions:
      "<a href='https://maps.gsi.go.jp/development/ichiran.html' target='_blank'>地理院タイル</a>", //出典の表記
      url: "https://cyberjapandata.gsi.go.jp/xyz/seamlessphoto/{z}/{x}/{y}.jpg",
      projection: "EPSG:3857" // CRS指定
    })
  });
  layerArray.push(photoOverlay);

  /* オーバーレイここまで */

  /*********** 地図のレイヤーを生成ここまで ***********/

  /*********** 地図のViewを生成 ***********/
  // 地図の表示に関する設定
  let mapView = new View({
    projection: "EPSG:3857",
    center: lonlat,
    maxZoom: 18, // 地理院の地図に合わせる
    zoom: zoomRate
  });

  /*********** 地図のViewを生成ここまで ***********/


  // マウス位置からの座標取得(PIN刺しに使用予定)
  const mousePositionControl = new MousePosition({ 
    coordinateFormat: createStringXY(4),
    projection: 'EPSG:4326',
    // comment the following two lines to have the mouse position
    // be placed within the map.
    // className: 'custom-mouse-position',
    // target: document.getElementById('mouse-position'),
  });

  // 小さな地図を表示
  const overviewMapControl = new OverviewMap({
    className: 'ol-overviewmap ol-custom-overviewmap',
    layers: [
      new TileLayer({
      source: new OSM({
      }),
    }),
    ],
    collapseLabel: '\u00BB',
    label: '\u00AB',
    collapsed: false,
  });

  // 地図を生成
  let map = new Map({
    interactions:
    olInteraction.defaults({
      altShiftDragRotate: false,
      pinchRotate: false,
    }),
    target: "map",
    render: ['canvas', 'dom'],
    layers: [
      new LayerGroup({
        title: "Base Map",
        layers: [
          vectorLayer,      
          fullBaseLayer,
          fullBlankLayer,
          fullReliefLayer,
          fullOsmLayer,
          fullPhotoLayer,
        ]
      }),
      new LayerGroup({
        title: "Overlay",
        layers: layerArray,

      }),
    ],
    controls: defaultControls().extend([mousePositionControl, overviewMapControl]),
    view: mapView
  });

  // ズームスライダーの追加(デフォルトデザイン)
  map.addControl(new ZoomSlider());

  // 標準の表示設定
  fullBaseLayer.setVisible(true);
  fullBlankLayer.setVisible(false);
  fullReliefLayer.setVisible(false);
  fullPhotoLayer.setVisible(false);
  fullOsmLayer.setVisible(false);

  /*********** センターマーカー表示 ここから ***********/
  function addCenterMarker(opt_options) {
    let options = opt_options || {};
    let anchor = document.createElement('a');
    let element = document.createElement('div');
    element.className = 'center_marker';
    element.id = 'centerMarker';
    element.appendChild(anchor);
    Control.call(this, { element: element, target: options.target });
  };

  let ol_ext_inherits = function(child,parent) {
    child.prototype = Object.create(parent.prototype);
    child.prototype.constructor = child;
  };
  ol_ext_inherits(addCenterMarker, Control);

  map.addControl(new addCenterMarker());
  // iconのレイヤーに対してのクリック操作を無効化する
  document.getElementById('centerMarker').style.pointerEvents = "none";
  document.getElementById('centerMarker').style.display = "block";
  /*********** センターマーカー表示 ここまで ***********/

  // Overlayの透過度を変更
  fullGraticule.setVisible(false);
  baseOverlay.setVisible(false);
  blankOverlay.setVisible(false);
  reliefOverlay.setVisible(false);
  osmOverlay.setVisible(false);
  photoOverlay.setVisible(false);

  fullGraticule.setOpacity(0.5);
  baseOverlay.setOpacity(0.5);
  blankOverlay.setOpacity(0.5);
  reliefOverlay.setOpacity(0.5);
  osmOverlay.setOpacity(0.5);
  photoOverlay.setOpacity(0.5);

  // スライダーは一括で持ってるようなので、順番を間違えないようにListで取得する
  let opSlider = document.getElementsByName('my_range');

  // 経緯線
  let grid_check = document.getElementById('checbox1');
  grid_check.addEventListener('change',function(evt){
    if(grid_check.checked) {
      fullGraticule.setVisible(true);
    } else {
      fullGraticule.setVisible(false);
    }
  });
  opSlider[0].addEventListener('input', function(e) {
    fullGraticule.setOpacity(this.value*0.01);
  });

  // 地理院地図
  let base_check = document.getElementById('checbox2')
  base_check.addEventListener('change',function(evt){
    if(base_check.checked) {
      baseOverlay.setVisible(true);
    } else {
      baseOverlay.setVisible(false);
    }
  });
  opSlider[1].addEventListener('input', function(e) {
    baseOverlay.setOpacity(this.value*0.01);
  });

  // 白地図
  let blank_check = document.getElementById('checbox3')
  blank_check.addEventListener('change',function(evt){
    if(blank_check.checked) {
      blankOverlay.setVisible(true);
    } else {
      blankOverlay.setVisible(false);
    }
  });
  opSlider[2].addEventListener('input', function(e) {
    blankOverlay.setOpacity(this.value*0.01);
  });

  // 色別標高図
  let relief_check = document.getElementById('checbox4')
  relief_check.addEventListener('change',function(evt){
    if(relief_check.checked) {
      reliefOverlay.setVisible(true);
    } else {
      reliefOverlay.setVisible(false);
    }
  });
  opSlider[3].addEventListener('input', function(e) {
    reliefOverlay.setOpacity(this.value*0.01);
  });

  // 航空写真
  let photo_check = document.getElementById('checbox5')
  photo_check.addEventListener('change',function(evt){
    if(photo_check.checked) {
      photoOverlay.setVisible(true);
    } else {
      photoOverlay.setVisible(false);
    }
  });
  opSlider[4].addEventListener('input', function(e) {
    photoOverlay.setOpacity(this.value*0.01);
  });

  // OSM
  let osm_check = document.getElementById('checbox6')
  osm_check.addEventListener('change',function(evt){
    if(osm_check.checked) {
      osmOverlay.setVisible(true);
    } else {
      osmOverlay.setVisible(false);
    }
  });
  opSlider[5].addEventListener('input', function(e) {
    osmOverlay.setOpacity(this.value*0.01);
  });


  // 近くの住所を検索
  document.getElementById('near_address').onclick = function() {
    getCenterLonLat();
  };

  let path = location.pathname + '/update';

  function getCenterLonLat() {
    const lonlat = transform(map.getView().getCenter(), 'EPSG:3857', 'EPSG:4326');
    //const element = document.getElementById("center-text");
    //element.textContent = lonlat;
  //  alert("lat:"+lonlat[1]+" / lot:"+lonlat[0]);
    // ここからControllerへLonLatの値を渡す
    $.ajax({
      url: path,
      type: "GET",
      data: {
        lon: lonlat[0],
        lat: lonlat[1]
      },
      dataType: "json"
    }).done(function(data){
      try {
        $('#address_target').children().remove();
        $('#address_target').html(data.html);  
      } catch (e) {
        $('#address_target').children().remove();
        $('#address_target').html('<p>住所情報を取得できませんでした。</p>');  
      }
    }).fail(function(){
      $('#address_target').children().remove();
      $('#address_target').html('<p>住所情報を取得できませんでした。</p>');
    });
  };

  /*********** 地図同期 ここから ***********/
  /**
   * 画面サイズによってレイアウトが変わる際、
   * 地図はそれぞれのレイアウトで生成されています。
   * そのため、1つの画面に2つの地図が存在することとなります。
   * 表示中の画面にある地図を操作後
   * 画面サイズが変わり非表示だった地図が表示された場合、
   * 非表示であった地図が初期情報のままだと問題があります。
   * そのため地図同士の同期を行い、操作状態を地図間で共有します。
   */
   let mapOption = document.getElementsByName('baselayer');
  // var smallMapOption = document.getElementsByName('small_baselayer');

  mapOption.forEach(function(e) {
    e.addEventListener("click", function() {
      let radioCheck = document.querySelector("input:checked[name=baselayer]").value
      mapChange(radioCheck);
    });
  });

  function mapChange(toggle) {
    if (toggle == "std") {
      fullBaseLayer.setVisible(true);
      fullBlankLayer.setVisible(false);
      fullReliefLayer.setVisible(false);      
      fullPhotoLayer.setVisible(false);
      fullOsmLayer.setVisible(false);
      // fullVector.setVisible(false);
    } else if (toggle == "blank") {
      fullBaseLayer.setVisible(false);
      fullBlankLayer.setVisible(true);
      fullReliefLayer.setVisible(false);
      fullPhotoLayer.setVisible(false);
      fullOsmLayer.setVisible(false);
      // fullVector.setVisible(false);
    } else if (toggle == "relief") {
      fullBaseLayer.setVisible(false);
      fullBlankLayer.setVisible(false);
      fullReliefLayer.setVisible(true);
      fullPhotoLayer.setVisible(false);
      fullOsmLayer.setVisible(false);
      // fullVector.setVisible(false);
    } else if (toggle == "photo") {
      fullBaseLayer.setVisible(false);
      fullBlankLayer.setVisible(false);
      fullReliefLayer.setVisible(false);
      fullPhotoLayer.setVisible(true);
      fullOsmLayer.setVisible(false);
      // fullVector.setVisible(false);
    } else if (toggle == "osm") {
      fullBaseLayer.setVisible(false);
      fullBlankLayer.setVisible(false);
      fullReliefLayer.setVisible(false);
      fullPhotoLayer.setVisible(false);
      fullOsmLayer.setVisible(true);
      // fullVector.setVisible(false);
    } else if (toggle == "vector") {
      fullBaseLayer.setVisible(false);
      fullBlankLayer.setVisible(false);
      fullReliefLayer.setVisible(false);
      fullPhotoLayer.setVisible(false);
      fullOsmLayer.setVisible(false);
      // fullVector.setVisible(true);
    }
  // debuglog
  //  console.log(document.querySelector("input:checked[name=baselayer]").value);
  }

  // ポップオーバーされる地図で流用してください
  // 2つのMAPの表示位置を同期させる(させない場合、近くの住所ボタンで正しい中央座標が取れない)
  // map.on('moveend', update_map);
  // small_map.on('moveend', update_small_map);

  // // MAP座標とZOOM率を同期させる
  // function update_map(event) {
  //   small_map.getView().setCenter(map.getView().getCenter(),null,true);
  //   small_map.getView().setZoom(map.getView().getZoom());
  // };

  // function update_small_map(event) {
  //   map.getView().setCenter(small_map.getView().getCenter(),true);
  //   map.getView().setZoom(small_map.getView().getZoom());
  // };

  /*********** 地図同期 ここまで ***********/


  // マウスクリック位置の座標取得
  map.on('click', function(evt) {
    const coordinate = evt.coordinate;
    const hdms = toStringHDMS(toLonLat(coordinate));
    // Webメルカトル(3857)から地図座標系(4326)に変換
    const lonlat = transform(evt.coordinate, 'EPSG:3857', 'EPSG:4326');

    // const element = document.getElementById("hdms");
    // element.textContent = hdms;
    // alert("lat:"+lonlat[1]+" / lot:"+lonlat[0]);
  });

  $(document).on("click", "[id^=overlay_]", function(e) {
    let layerId = $(e.target).attr("id").substring(8);
    let tile = objMap.get(layerId)
    let bool = tile.getVisible();
    tile.setVisible(!bool);
  });

  // 追加レイヤーの透過スライダーは固定スライダーと違い、それぞれのID付きなnameを持っている
  // Mapのレイヤー全てに対してListenerを登録する

  // 追加レイヤー用スライダー表示
  $('.list_checkbox_superposition').each(function () {
    let $this = $(this);
    let $form = $this.find('.form_check_input');
    let $range = $this.find('.overlay_list');

    $form.on('click', function () {
        if ($form.is(':checked')) {
            $range.removeClass('d-none');
        } else {
            $range.addClass('d-none');
        }
    });
  });

  $('.overlay_list').each(function () {
    let $this = $(this);
    let $range = $this.find('.range_sliders');
    let $value = $this.find('.value_range');

    $this.on('input', $range, function () {
        $value.val($range.val() + '%');
    })
  });
  let mapUrl;

  ///////////////////////////////////////

  // 地図書き出しが終わったら立てる
  let captureFlag = false;

  // Zoom率変更後、レンダリングが終わったときに処理する
  map.on('rendercomplete', function () {

    if(captureFlag){
      return;
    }

    let zoom = map.getView().getZoom();
    const mapCanvas = document.createElement('canvas');
    const size = map.getSize();
    mapCanvas.width = size[0];
    mapCanvas.height = size[1];
    mapCanvas.crossOrigin = "anonymous";
    const mapContext = mapCanvas.getContext('2d');

    // main
    if(zoom == zoomRate) {
      Array.prototype.forEach.call(
        document.querySelectorAll('.main-capture canvas'),
        function (canvas) {
          if (canvas.width > 0) {
            const opacity = canvas.parentNode.style.opacity;
            mapContext.globalAlpha = opacity === '' ? 1 : Number(opacity);
            const transform = canvas.style.transform;
            const matrix = transform
              .match(/^matrix\(([^\(]*)\)$/)[1]
              .split(',')
              .map(Number);
            CanvasRenderingContext2D.prototype.setTransform.apply(
              mapContext,
              matrix
            );
            canvas.crossOrigin = "anonymous";
            mapContext.drawImage(canvas, 0, 0);
          }
        }
      );
    
      if (navigator.msSaveBlob) {
        navigator.msSaveBlob(mapCanvas.msToBlob(), 'map.png');
      } else {
        const link = document.getElementById('image-download-main');
        mapCanvas.crossOrigin = 'anonymous';
        mapUrl = mapCanvas.toDataURL();
        link.href = mapUrl;
        $(".map_url").val(link.href)
      }  
      map.getView().setZoom(3);
    }

    if (zoom == 3){
      Array.prototype.forEach.call(
        document.querySelectorAll('.main-capture canvas'),
        function (canvas) {
          if (canvas.width > 0) {
            const opacity = canvas.parentNode.style.opacity;
            mapContext.globalAlpha = opacity === '' ? 1 : Number(opacity);
            const transform = canvas.style.transform;
            const matrix = transform
              .match(/^matrix\(([^\(]*)\)$/)[1]
              .split(',')
              .map(Number);
            CanvasRenderingContext2D.prototype.setTransform.apply(
              mapContext,
              matrix
            );
            canvas.crossOrigin = "anonymous";
            mapContext.drawImage(canvas, 0, 0);
          }
        }
      );

      if (navigator.msSaveBlob) {
        navigator.msSaveBlob(mapCanvas1.msToBlob(), 'map1.png');
      } else {
        const link = document.getElementById('image-download-main1');
        mapCanvas.crossOrigin = 'anonymous';
        mapUrl = mapCanvas.toDataURL();
        link.href = mapUrl;
        $(".map_url1").val(link.href)
      }
      map.getView().setZoom(7);
    }

    if (zoom == 7){
      Array.prototype.forEach.call(
        document.querySelectorAll('.main-capture canvas'),
        function (canvas) {
          if (canvas.width > 0) {
            const opacity = canvas.parentNode.style.opacity;
            mapContext.globalAlpha = opacity === '' ? 1 : Number(opacity);
            const transform = canvas.style.transform;
            const matrix = transform
              .match(/^matrix\(([^\(]*)\)$/)[1]
              .split(',')
              .map(Number);
            CanvasRenderingContext2D.prototype.setTransform.apply(
              mapContext,
              matrix
            );
            canvas.crossOrigin = "anonymous";
            mapContext.drawImage(canvas, 0, 0);
          }
        }
      );

      if (navigator.msSaveBlob) {
        navigator.msSaveBlob(mapCanvas.msToBlob(), 'map2.png');
      } else {
        const link = document.getElementById('image-download-main2');
        mapCanvas.crossOrigin = 'anonymous';
        mapUrl = mapCanvas.toDataURL();
        link.href = mapUrl;
        $(".map_url2").val(link.href)
      }
      map.getView().setZoom(10);
    }

    if (zoom == 10){
      Array.prototype.forEach.call(
        document.querySelectorAll('.main-capture canvas'),
        function (canvas) {
          if (canvas.width > 0) {
            const opacity = canvas.parentNode.style.opacity;
            mapContext.globalAlpha = opacity === '' ? 1 : Number(opacity);
            const transform = canvas.style.transform;
            const matrix = transform
              .match(/^matrix\(([^\(]*)\)$/)[1]
              .split(',')
              .map(Number);
            CanvasRenderingContext2D.prototype.setTransform.apply(
              mapContext,
              matrix
            );
            canvas.crossOrigin = "anonymous";
            mapContext.drawImage(canvas, 0, 0);
          }
        }
      );

      if (navigator.msSaveBlob) {
        navigator.msSaveBlob(mapCanvas.msToBlob(), 'map3.png');
      } else {
        const link = document.getElementById('image-download-main3');
        mapCanvas.crossOrigin = 'anonymous';
        mapUrl = mapCanvas.toDataURL();
        link.href = mapUrl;
        $(".map_url3").val(link.href)
      }
      map.getView().setZoom(18);
    }

    if (zoom == 18){
      Array.prototype.forEach.call(
        document.querySelectorAll('.main-capture canvas'),
        function (canvas) {
          if (canvas.width > 0) {
            const opacity = canvas.parentNode.style.opacity;
            mapContext.globalAlpha = opacity === '' ? 1 : Number(opacity);
            const transform = canvas.style.transform;
            const matrix = transform
              .match(/^matrix\(([^\(]*)\)$/)[1]
              .split(',')
              .map(Number);
            CanvasRenderingContext2D.prototype.setTransform.apply(
              mapContext,
              matrix
            );
            canvas.crossOrigin = "anonymous";
            mapContext.drawImage(canvas, 0, 0);
          }
        }
      );

      if (navigator.msSaveBlob) {
        navigator.msSaveBlob(mapCanvas.msToBlob(), 'map4.png');
      } else {
        const link = document.getElementById('image-download-main4');
        mapCanvas.crossOrigin = 'anonymous';
        mapUrl = mapCanvas.toDataURL();
        link.href = mapUrl;
        $(".map_url4").val(link.href)
      }
      map.getView().setZoom(zoomRate);
      captureFlag = true;
    }
  });


  // ブラウザバック時はぐるぐる出さない
  const loader = document.getElementById('js-loader');

  history.replaceState(null,null,null);
  window.addEventListener('popstate', function (e) {
    loader.style.opacity = 0;
    loader.style.display = "none";
  });

  window.addEventListener('load', () => {
    const ms = 400;
    loader.style.transition = 'opacity ' + ms + 'ms';
    
    const loaderOpacity = function(){
      loader.style.opacity = 0;
    }
    const loaderDisplay = function(){
      loader.style.display = "none";
    }
    // setTimeout(loaderOpacity, 1);
    // setTimeout(loaderDisplay, ms);
    // デモ用
    setTimeout(loaderOpacity, 2000);
    setTimeout(loaderDisplay, 2000 + ms);
  });

  // map.getView().setZoom(zoomRate);
}

$(function () {

  // 地図の見方をクリックした場合のモーダル画面表示
  $(document).on("click", ".btn_read_map", function(){
    
  })

  // 「不適切な報告」ボタンをクリックした場合モーダル画面表示
  $(document).on("click", ".btn_report", function () {
    let report_class = $(this).attr("class");
    let modal = report_class.split(" ");
    let modal_num = modal[1].split("_");

    $('.report_article_' + modal_num[3]).fadeIn();

    return false;
  });

  // 「不適切な報告」ボタンをクリックした場合モーダル画面を閉じる
  $(document).on("click", ".report-modal-close", function () {
      $('.modal_report_article').fadeOut();
      $('.tab_report').addClass("active");
      $('.tab_contributor').removeClass("active");
      $('.content_tab_contributor').addClass("d-none");
      $('.content_tab_report').removeClass("d-none");
      $(".report_result").text("");
      $(".alert-warning").remove();
      $("input:radio[name='report[violation_type]']:radio[value='6']").prop("checked", true);
      $(".report_text").val("");
      return false;
  });

  //「ⓧ」ボタンをクリックした場合、モーダル画面を閉じる
  $(document).on("click", ".btn_close_modal", function () {
      $('.modal_report_article').fadeOut();
      $('.tab_report').addClass("active");
      $('.tab_contributor').removeClass("active");
      $('.content_tab_contributor').addClass("d-none");
      $('.content_tab_report').removeClass("d-none");
      $(".report_result").text("");
      $(".alert-warning").remove();
      $("input:radio[name='report[violation_type]']:radio[value='6']").prop("checked", true);
      $(".report_text").val("");
      return false;
  });

  // 「不適切な投稿者の報告」をクリックした場合
  $(document).on("click", ".tab_contributor", function () {
      let report_class = $(this).attr("class");
      let modal = report_class.split(" ");
      let modal_num = modal[1].split("_");

      $(this).addClass("active");
      $(".contributor_tab_" + modal_num[2]).removeClass("d-none");
      $(".link_report_" + modal_num[2]).removeClass("active");
      $(".report_tab_" + modal_num[2]).addClass("d-none");
      $(".report_result").text("");
      $("input:radio[name='report[violation_type]']:radio[value='8']").prop("checked", true);
      $(".alert-warning").remove();
  });

  // 「不適切な投稿記事の報告」をクリックした場合
  $(document).on("click", ".tab_report", function () {
      let report_class = $(this).attr("class");
      let modal = report_class.split(" ");
      let modal_num = modal[1].split("_");

      $(this).addClass("active");
      $(".report_tab_" + modal_num[2]).removeClass("d-none");
      $(".link_contributor_" + modal_num[2]).removeClass("active");
      $(".contributor_tab_" + modal_num[2]).addClass("d-none");
      $("input:radio[name='report[violation_type]']:radio[value='6']").prop("checked", true);
      $(".report_result").text("");
      $(".alert-warning").remove();
  });

 // 地図の見方についてのモーダル画面を開く
 $('.btn_read_map').on('click', function () {
    $('#modal_use_map_about').fadeIn();
    return false;
  });

  //地図の見方についてのモーダル画面の外部をクリックした場合、 モーダル画面を閉じる 
  $('.map-use-modal-close').on('click', function () {
    $('#modal_use_map_about').fadeOut();
    return false;
  });

  //地図の見方についてのモーダル画面の「ⓧ」 ボタンをクリックした場合、 モーダル画面を閉じる
  $('.map_read_close_modal').on('click', function () {
    $('#modal_use_map_about').fadeOut();
    return false;
  });


});